import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { Wrapper, StyledTypography } from "./ui/styled";

const NotFound: FC = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/");
  };

  return (
    <Wrapper>
        <span>Что-то пошло не так...&nbsp;</span>
        <StyledTypography onClick={handleBack}>
          давайте вернемся
        </StyledTypography>
    </Wrapper>
  );
};

export default NotFound;
